import React from 'react';
import { useNavigate } from "react-router-dom";

import 'Container/PlanSite/PlanSite.scss';
import { useSelector } from "react-redux";
import { isAdminKc } from "../../utils/keycloakUtils";
import { decode } from "html-entities";

export default function PlanSite() {

    const {
        keycloakReduce,
        infosCorrespondant,
        mnhPratique,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    console.log("mnhPratique")
    console.log(mnhPratique)

    const CONF = window?.confPub;
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES;
    const ROUTE_LABEL = CONF?.LINK_LABEL?.ROUTES;

    const navigate = useNavigate();

    return (
        <div className='container plan-site-container mt-3'>

            <main id="content">

                <h1>PLAN DU SITE</h1>

                <ul>
                    <li>
                        <a className="bold" onClick={ () => navigate(ROUTES_PAGES?.ROOT) }>
                            { ROUTE_LABEL?.ACCUEIL }
                        </a>
                    </li>
                    <li>
                        <a className="liens bold-lien" onClick={ () => navigate(ROUTES_PAGES?.RECHERCHE_PERSONNE) }>
                            { ROUTE_LABEL?.RECHERCHE_PERSONNE }
                        </a>
                    </li>
                    <li>
                        <span className='bold'>{ ROUTE_LABEL?.FICHE_PERSONNE }</span>
                    </li>
                    <li>
                        <span className='bold'>{ ROUTE_LABEL?.FICHE_CONTRAT }</span>
                    </li>
                    <li>
                        <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.MAIN }</span>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_ADRESSE }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_COORDONNEES }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_NOM }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_NIR }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_GARANTIE }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.DOCUMENT }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_SITUATION }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.AJOUT_AYANT_DROIT }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.RADIATION_AYANT_DROIT }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.DECLARAION_DECES }</span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span className='bold'>{ ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_RIB }</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a className="liens bold-lien"
                           onClick={ () => navigate(ROUTES_PAGES?.ANNUAIRE_CORRESPONDANTS) }>
                            { ROUTE_LABEL?.ANNUAIRE_CORRESPONDANTS }
                        </a>
                    </li>
                    <li>
                        <a className="liens bold-lien"
                           onClick={ () => navigate(ROUTES_PAGES?.ANNUAIRE_CORRESPONDANTS) }>
                            { ROUTE_LABEL?.ACTUALITES }
                        </a>
                    </li>
                    <li>
                        <span className='bold'>{ ROUTE_LABEL?.MNH_PRATIQUE }</span>
                        <ul>

                            { mnhPratique?.length > 0 && mnhPratique.map((page, key) => (
                                <li key={ key }>
                                    <a className="liens bold-lien"
                                       onClick={ () => navigate(`/mnh-pratique${ page?.pageUrl }`) }
                                    >
                                        { decode(page?.pageLibelle) }
                                    </a>
                                </li>
                            )) }
                        </ul>
                    </li>

                    { isAdminKc(keycloakReduce?.decodedToken) && (
                        <li>
                            <span className='bold'>{ ROUTE_LABEL?.ADMINISTRATION_CONTENU }</span>
                            <ul>
                                <li>
                                    <a className="liens bold-lien"
                                       onClick={ () => navigate(ROUTES_PAGES?.ADMIN?.AJOUTER_MODIFIER_MSG_ACCUEIL) }>
                                        { ROUTE_LABEL?.AJOUTER_MODIFIER_MSG_ACCUEIL }
                                    </a>
                                </li>
                                <li>
                                    <a className="liens bold-lien"
                                       onClick={ () => navigate(ROUTES_PAGES?.ADMIN?.AJOUTER_CONTRIBUTION) }>
                                        { ROUTE_LABEL?.AJOUTER_CONTRIBUTION }
                                    </a>
                                </li>
                            </ul>


                        </li>
                    ) }

                    <li>
                    <a className="liens bold-lien"
                           onClick={ () => navigate(ROUTES_PAGES?.PROFIL?.MAIN) }>
                            { ROUTE_LABEL?.PROFIL }
                        </a>
                    </li>
                    <li>
                        <a className="liens bold-lien"
                           onClick={ () => navigate(ROUTES_PAGES?.ACCESSIBILITE) }>
                            { ROUTE_LABEL?.ACCESSIBILITE }
                        </a>
                    </li>
                </ul>


            </main>

        </div>
    )
}